module.exports = __webpack_public_path__ + "static/media/pic12.8072b6fc.jpg";